<template>
  <SubContent h="550px" @back="showTip = true">
    <template v-slot:nav_left> 精英机构/基地信息设置 </template>
    <div class="form_wrap">
      <vue-scroll>
        <el-form
          ref="unitForm"
          :model="centerInfo"
          :rules="formRules"
          label-width="145px"
          class="black_form"
        >
          <el-row class="organName">
            <el-col :span="16" style="display: flex">
              <div class="label">当前管理行政部门</div>
              <el-input
                v-model.trim="centerInfo.organShortName"
                disabled
                placeholder="请输入区体育行政部门全称（50个字以内）"
              ></el-input>
              <!--              <el-form-item  label="所属区体育行政部门" prop="organName" >-->
              <!--                <el-input v-model.trim="centerInfo.organShortName" disabled placeholder="请输入区体育行政部门全称（50个字以内）"></el-input>-->
              <!--              </el-form-item>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="全称" prop="youthName">
                <el-input
                  v-model.trim="centerInfo.youthName"
                  disabled
                  placeholder="请输入全称（50个字以内）"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="简称" prop="youthShortName">
                <el-input
                  v-model.trim="centerInfo.youthShortName"
                  disabled
                  placeholder="请输入简称（20个字以内）"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="管理员" prop="idName">
                <el-input
                  v-model.trim="centerInfo.idName"
                  disabled
                  placeholder="请输入管理员姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="provinceSettingTra">
            <div class="label">所属区域</div>
            <!-- <el-col :span="5" style="margin-right: 20px">
              <el-form-item  label-width="0" prop="provinceCode">
                <el-select v-model="centerInfo.provinceCode" placeholder="请选择省" @change="changeProvince">
                  <el-option
                    v-for="item in regions"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="5" style="margin-right: 20px">
              <el-form-item label-width="0" prop="cityCode">
                <el-select
                  v-model="centerInfo.cityCode"
                  placeholder="请选择市"
                  @change="changeCity"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="5" :offset="1">
              <el-form-item label-width="0" prop="countyCode">
                <el-select
                  v-model="centerInfo.countyCode"
                  placeholder="请选择区"
                  @change="changeCountyYouthSetting"
                >
                  <el-option
                    v-for="item in sh_county_list"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="详细地址">
                <el-input
                  v-model.trim="centerInfo.address"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="联系电话">
                <el-input
                  v-model.trim="centerInfo.telNumber"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="上传logo">
            <UploadImg :imgUrl.sync="centerInfo.banner" :avatarUrl.sync="img" />
            <div style="font-size: 16px">支持jpg,jpeg,bmp,gif,png格式上传</div>
          </el-form-item>
        </el-form>
      </vue-scroll>
    </div>
    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" style="margin-right: 20px" @click="save"
          >保存</el-button
        >
        <el-button type="danger" @click="showTip = true">取消</el-button>
      </div>
    </template>
    <yioks-tip
      :showTip="showTip"
      :tipMsg="$t('waivedSubmission')"
      @callback="goBack"
    ></yioks-tip>
  </SubContent>
</template>

<script>
import regions from "@/utils/regions";
import rules from "@/utils/formRules/center";
import club from "@/api/club";

export default {
  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    UploadImg: () => import("@/components/UploadImg"),
  },
  mixins: [rules],
  data() {
    return {
      img: "",
      regions,
      cityList: [],
      showTip: false,
      centerInfo: {
        organShortName: "",
        address: "",
        telNumber: "",
        banner: "",
        status: "",
        countyCode: '',
        cityCode: "",
        provinceCode: "",
        youthShortName: "",
        countyName: "",
        youthName: "",
        idName: "",
      },
    };
  },
  computed: {
    sh_county_list() {
      let arr = [];
      regions.forEach((item) => {
        if (item.code === "31") {
          const { county, name } = item.city[0];
          arr = county;
        }
      });
      return arr;
    },
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      club
        .getYouthSettingData()
        .then((res) => {
          this.loading = false;
          const { youth } = res;
          this.centerInfo = {
            organShortName: youth.organShortName,
            youthName: youth.youthName,
            address: youth.address || "",
            telNumber: youth.telNumber || "",
            youthShortName: youth.youthShortName,
            banner: youth.banner ? youth.banner : "",
            organUserName: youth.organUserName,
            cityCode: String(youth.cityCode),
            cityName: youth.cityName,
            provinceName: youth.provinceName,
            provinceCode: String(youth.provinceCode),
            countyCode: youth.countyCode == 0 ? '' : String(youth.countyCode),
            idName: youth.adminName,
          };
          this.regions.forEach((item) => {
            if (item.code === this.centerInfo.provinceCode) {
              this.cityList = item.city;
            }
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    goBack(isSure) {
      if (isSure) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },
    save() {
      this.$refs["unitForm"].validate((valid) => {
        if (valid) {
          const data = {
            address: this.centerInfo.address,
            banner: this.centerInfo.banner,
            cityCode: this.centerInfo.cityCode,
            cityName: this.centerInfo.cityName,
            provinceCode: this.centerInfo.provinceCode,
            provinceName: this.centerInfo.provinceName,
            countyCode: this.centerInfo.countyCode,
            countyName: this.centerInfo.countyName,
            telNumber: this.centerInfo.telNumber,
          };
          // return
          club.setYouthSettingData(data).then((res) => {
            // storage.set('unitInfo', res)
            if (res.code) {
              this.$message.success(res.msg);
              this.$router.go(-1);
            } else {
              this.$message.success("修改成功");
              this.$router.go(-1);
            }
          });
        }
      });
    },
    changeCity() {
      this.centerInfo.cityName = this.cityList.find((item) => {
        return item.code === this.centerInfo.cityCode;
      }).name;
    },
    changeCountyYouthSetting() {
      this.centerInfo.countyName = this.sh_county_list.find(item => {
        return item.code === this.centerInfo.countyCode
      }).name || ''
    },
    changeProvince() {
      if (this.centerInfo.provinceCode) {
        this.regions.forEach((item) => {
          if (item.code === this.centerInfo.provinceCode) {
            this.cityList = item.city;
            this.$set(this.centerInfo, "cityCode", this.cityList[0].code);
            this.$set(this.centerInfo, "cityName", this.cityList[0].name);
            this.$set(this.centerInfo, "provinceName", item.name);
          }
        });
      } else {
        this.$set(this.centerInfo, "cityCode", "");
        this.$set(this.centerInfo, "cityName", "");
        this.$set(this.centerInfo, "provinceName", "");
        this.cityList = [];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px 0 20px 60px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  .black_form
    margin-right 30px
    .setting_btn
      width 80px
      background $green_color2
      text-align center
      font-size 16px
      height 40px
      line-height 40px
      border-radius 5px
.btn_wrap
  width 100%
  display flex
  justify-content center
</style>

<style lang="stylus" scoped>
.provinceSettingTra
  display flex
  .label
    width 145px
    height 40px
    line-height 40px
    text-align center
    &:before
      content '*'
      color #F56C6C
      margin-right 4px
.organName
  margin-bottom 22px
  .label
    width 200px
    height 40px
    line-height 40px
    text-align center
    &:before
      content '*'
      color #F56C6C
      margin-right 4px
</style>

